import * as yup from 'yup';
export const customLabelSchema = yup
    .object()
    .camelCase()
    .shape({
    id: yup.string().required().ensure(),
    labelId: yup.number().nullable(),
    labelName: yup.string().defined(),
    labelColor: yup.string().defined()
});
